import $ from "jquery";
import GLightbox from "glightbox";

$(window).on('load', function () {
	$(".glightbox").on("click", function (e) {
		e.preventDefault();
	});
	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
	});

	const loadMoreBtn = document.querySelector(".load-more-photos");
	const batches = document.querySelectorAll(".photo-batch");
	let visibleBatches = 1;

	if (loadMoreBtn) {
		loadMoreBtn.addEventListener("click", function () {
			if (visibleBatches < batches.length) {
				batches[visibleBatches].classList.remove("d-none");
				visibleBatches++;

				if (visibleBatches === batches.length) {
					loadMoreBtn.textContent = "Load Less";
				}
			} else {
				for (let i = 1; i < batches.length; i++) {
					batches[i].classList.add("d-none");
				}
				visibleBatches = 1;
				loadMoreBtn.textContent = "Load More";
			}
		});
	}
});
